module.exports = __webpack_public_path__ + "img/Photo_1__Fourth_Canal_992_36_12.45eb9ab5.jpg";